export default ({ app }) => {
  const userAgent = navigator.userAgent.toLowerCase()
  // androidでないsafariかつ、タッチイベントが有効である場合はiOSとみなす
  const iOS =
    !userAgent.includes('android') && userAgent.indexOf('safari') > 0 && typeof document.ontouchstart !== 'undefined'

  // manifestのlinkタグを生成
  function setManifest(path) {
    const manifest = document.createElement('link')
    manifest.rel = 'manifest'
    manifest.href = path
    manifest.crossOrigin = 'use-credentials'
    document.head.appendChild(manifest)
  }

  let dirName = ''
  switch (process.env.NODE_BUILD_ENV) {
    case 'prd':
      dirName = ''
      break
    case 'stg':
    case 'stg1':
      dirName = '/stg'
      break
    case 'stg2':
      dirName = '/stg2'
      break
    case 'dev':
      dirName = '/dev'
      break
    case 'dev2':
      dirName = '/dev2'
      break
    case 'dev3':
      dirName = '/dev3'
      break
    default:
      dirName = '/dev'
      break
  }

  let manifestPath = `${app.router.history.base}/manifest`
  if (iOS) {
    manifestPath += `/ios${dirName}/manifest.json`
  } else {
    manifestPath += `/android${dirName}/manifest.json`
  }

  setManifest(manifestPath)
}
